module.exports = __webpack_public_path__ + "static/striker-videoplayer-tallyman.v1-pin/files/025b960c88cd0964250220826b15d251.jpg";